import {AfterViewInit, Component, forwardRef, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CompleterCmp, CompleterData, CompleterItem} from "ng2-completer";
import {AppRestCompleterService} from "../../../core/services/app-rest-completer.service";
import {StammdatenortschaftService} from "../../../core/stammdaten-api/api/stammdatenortschaft.service";
import {of, Subscription} from "rxjs";
import {OrtschaftListEntry} from "../../../core/stammdaten-api";
import {CapFormControlComponent} from 'app/shared/form-control/form-control.component';

@Component({
  selector: 'cap-ortschaft-selection',
  templateUrl: './ortschaft-selection.component.html',
  styleUrls: ['./ortschaft-selection.component.scss'],
  host: {
    "class": "form-control-component"
  },
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => OrtschaftSelectionComponent), multi: true},
    AppRestCompleterService,
  ]
})
export class OrtschaftSelectionComponent implements OnInit, AfterViewInit, ControlValueAccessor, OnDestroy {

  @ViewChild(CompleterCmp, {static: false})
  completer: CompleterCmp;

  ortschaftListEntryVm: Array<OrtschaftListEntryVm>;

  public isOpen = false;
  openCloseFocused;
  dataService: CompleterData;
  value = '';

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  private reset = false;
  titleFields: string;

  private subscription: Subscription;

  constructor(private completerService: AppRestCompleterService,
              private ortschaftService: StammdatenortschaftService,
              @Optional() private formControlComponent: CapFormControlComponent) {
  }

  ngAfterViewInit() {
    if (this.formControlComponent) {
      this.formControlComponent.registerChild(this.completer.ctrInput);
    }
  }


  ngOnInit() {
    const findAll = this.ortschaftService.loadAll();
    findAll.subscribe(ortschaften => {
      this.createViewModel(ortschaften);
      this.titleFields = 'name,plzAsString';
      const searchFields = this.titleFields;
      this.dataService = this.completerService.local(of(this.ortschaftListEntryVm), searchFields, this.titleFields);
    });
  }

  private createViewModel(ortschaften: OrtschaftListEntry[]) {
    this.ortschaftListEntryVm = new Array<OrtschaftListEntryVm>();
    for (const ortschaft of ortschaften) {
      const entry = new OrtschaftListEntryVm(
        ortschaft
      );
      this.ortschaftListEntryVm.push(entry);
    }
  }

  writeValue(ortschaftVersionId: string): void {
    if (ortschaftVersionId) {
      this.subscription = this.ortschaftService.load1(ortschaftVersionId).subscribe(ortschaft => {
        if (ortschaft.plz != null) {
          this.value = ortschaft.name + ' ' + ortschaft.plz;
        } else {
          this.value = ortschaft.name;
        }
        this.reset = false;
      });
    } else if (!this.reset) {
      this.reset = true;
      this.value = null;
    }
  }


  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  public onOpened(isOpen: boolean) {
    this.isOpen = isOpen;
  }

  onClick() {
    if (this.completer.disableInput === true) {
      this.completer.close();
    } else {
      if (this.isOpen) {
        this.value = '';
        this.propagateChange(null);
      }
    }
  }

  onSelected(selectedItem: CompleterItem) {
    if (selectedItem) {
      const obj = selectedItem.originalObject;
      this.value = this.titleFields.split(',').map(fieldName => obj[fieldName]).join(' ');
      this.propagateChange(obj.object.versionId.id);
      this.reset = false;
    } else {
      this.value = '';
      this.propagateChange(null);
    }
  }

  public emptyCompleter() {
    this.completer.value = "";
    this.value = "";
    this.onSelected(null);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}

class OrtschaftListEntryVm {

  public plzAsString: string;
  public name: string;

  constructor(public object: OrtschaftListEntry) {
    this.plzAsString = object.plz === null ? "" : "" + object.plz;
    this.name = object.name;
  }
}
